module.exports = __webpack_public_path__ + "img/18.90a01ae5.jpg";